var $ = jQuery;
/* eslint-disable */
// import selectric from '../libs/dropdowns-ugh.js';
/* eslint-enable */

function init() {
  $('.filter-wrapper__filter').selectric({arrowButtonMarkup: '<span class="arrow-button"></span>'});
  $('.results-wrapper .facets-dropdown').selectric({arrowButtonMarkup: '<span class="arrow-button"></span>'});
  $('.results-wrapper .facets-dropdown').on('selectric-change', function() {
    let selectVal = $(this).closest('.selectric-hide-select').find('select').val();
    window.location.assign(selectVal);
    //.trigger('change');
  });
  $('#edit-field-areas-of-expertise-target-id').selectric({
    arrowButtonMarkup: '<span class="arrow-button"></span>',
    onInit: function() {
      $('.about-staff').addClass('selectric-active');
    }
  });
  $('#edit-field-areas-of-expertise-target-id').on('selectric-change change', function() {
    $(this).closest('.views-exposed-form').submit();
  });

}

export { init as init };
